import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex w-100 justify-space-between" }
const _hoisted_2 = { class: "d-flex gap-1" }
const _hoisted_3 = { class: "d-flex flex-column" }
const _hoisted_4 = { class: "d-flex ml-8 flex-column" }
const _hoisted_5 = {
  class: "ml-10 d-flex",
  style: {"position":"absolute","right":"20px"}
}
const _hoisted_6 = { class: "d-flex align-center" }
const _hoisted_7 = {
  class: "hours-color",
  style: {"font-weight":"600"}
}

import { withDefaults } from 'vue';
import { ClockIcon } from '@/components/atoms';
interface IProps {
  title_one: string;
  subtitle_one: string;
  title_two: string;
  subtitle_two: string;
  hours: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardData',
  props: {
    title_one: { default: '' },
    subtitle_one: { default: '' },
    title_two: { default: '' },
    subtitle_two: { default: '' },
    hours: { default: '' }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_card_title, { class: "title text-md pb-1" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.title_one), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_subtitle, { class: "subtitle text-sm" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.subtitle_one), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_card_title, { class: "title text-md pb-1" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.title_two), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_subtitle, { class: "subtitle text-sm" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.subtitle_two), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (props.hours)
        ? (_openBlock(), _createBlock(_component_v_card_title, {
            key: 0,
            class: "title text-lg font-weight-medium"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(ClockIcon), { class: "mr-1" }),
                _createElementVNode("span", _hoisted_7, _toDisplayString(props.hours), 1)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})